import { actionTypes } from "./constants";

export const initialState = {
    data: null,   
    previousRequestSource: null,
    fetching: false,
}

export const visitorMetricsReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_VISITOR_METRICS_DATA:
            return {
                ...state,
                data: action.payload
            }
        case actionTypes.SET_VISITOR_METRICS_CANCEL_TOKEN:
            return {
                ...state,
                previousRequestSource: action.previousRequestSource
            }
        case actionTypes.IS_VISITOR_METRICS_FETCHING:
            return {
                ...state,
                fetching: action.fetching
            }
        default:
            return state;
    }
} 